import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import Alert from "react-s-alert";
import { paths, RESPONSE_STATUS, STATUS_TYPE } from "utils/constants";
import { gotoUrl, getChannelFromUrl } from "utils/helpers";
import { Flex } from "ui-components";
import Spinner, { styles } from "components/Spinner";
import PaymentAdyenDropin from "components/PaymentAdyenDropin";

function PaymentUpdateCardAdyenDropIn({
  isFetchingPaymentDetails,
  paymentDetails,

  saveAndGetPaymentCardDetails,
  processCardUpdatePayment,

  currencyCode,
  token,
  returnUrl,
  orderSessionToken,
  webTxnId
}) {
  const channel = getChannelFromUrl();
  const loading = isEmpty(paymentDetails) || isFetchingPaymentDetails;

  useEffect(() => {
    if (isEmpty(paymentDetails) && !isFetchingPaymentDetails) {
      saveAndGetPaymentCardDetails(
        {
          paymentMethod: "card",
          txn_id: webTxnId,
          uuid: webTxnId,
          token: token || orderSessionToken,
          currency: currencyCode,
          additional_data: {
            custom_payment_method: "card"
          }
        },
        (_, error) => {
          if (!isEmpty(error)) {
            Alert.error(error);
          }
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // onSubmit method get fired when you click on the CTA button on the Adyen Dropin. Here we need to register the payment using processCardUpdatePayment api call.
  const onSubmit = (state, dropin) => {
    const {
      data: { paymentMethod, browserInfo, riskData }
    } = state;
    let payload = {
      paymentMethod,
      browserInfo,
      riskData,
      origin: window.location.origin,
      channel: "Web",
      instrument_data: {
        redirect_url: `${window.location.origin}${paths.PAYMENT_STATUS.replace(
          ":channel",
          channel
        )}?type=${STATUS_TYPE.TRANSACTION}${returnUrl &&
          `&return_url=${returnUrl}`}`
      },
      token: token || orderSessionToken
    };

    dropin.setStatus("loading");

    processCardUpdatePayment(payload, result => {
      // if 3ds flow use dropin method to redirect user to the verification page
      if (
        result?.status === RESPONSE_STATUS.SUBMITTED &&
        result?.action_object
      ) {
        dropin.handleAction(result.action_object);
      } else if (result?.status === RESPONSE_STATUS.SUCCESS) {
        // if adyen didn't trigger the 3ds flow and if the payment is a success redirect user to the payment status page and it will show the success page.
        gotoUrl(
          paths.PAYMENT_STATUS.replace(":channel", channel),
          true,
          { type: STATUS_TYPE.TRANSACTION, return_url: returnUrl, reset: null },
          false
        );
      } else {
        dropin.setStatus("ready");
        Alert.error(
          `Payment unsuccessful please try again!!! (${result.error_message})`
        );
      }
    });
  };

  return (
    <Flex minHeight={"282px"} alignItems={"center"} justifyContent={"center"}>
      {loading ? (
        <Spinner size={200} sx={styles.modalContainer} />
      ) : (
        <PaymentAdyenDropin
          paymentRequestData={paymentDetails}
          loading={loading}
          onSubmit={onSubmit}
        />
      )}
    </Flex>
  );
}

export default PaymentUpdateCardAdyenDropIn;
